import {useState} from 'react';

import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import {useTheme} from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import { useNavigateToTop } from '@src/hooks/useNavigateToTop';
import ScheduleDemoButton from '@src/layout/Header/ScheduleDemoButton.jsx';

import HeaderDesktopNavMenu from './HeaderDesktopNavigationMenu';
import HeaderLogo from './HeaderLogo';
import HeaderRoot from './HeaderRoot';
import MobileMenu, { MOBILE_MENU_ID } from './MobileMenu';

function Header({currentPage, onNavigate = () => {} }) {
  const onNavigateToTop = useNavigateToTop();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  const [mobileOpen, setMobileOpen] = useState(false);
  const [prodAnchor, setProdAnchor] = useState(null);
  const [servAnchor, setServAnchor] = useState(null);

  const handleNavigate = (to) => {
    onNavigate(to);
    setMobileOpen(false);
    setProdAnchor(null);
    setServAnchor(null);
    // Mirror useNavigateToTop's scroll behavior so menu/drawer clicks land at the top of the new page.
    window.scrollTo(0, 0);
  };

  const mobileMenuOpen = !isDesktop && mobileOpen;

  return (
    <HeaderRoot
      sx={{
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        minHeight: 64,
        display: 'flex',
        alignItems: 'center',
        px: 3,
      }}
    >
      {/* Logo */}
      <HeaderLogo onClick={() => handleNavigate('/')} />

      {/* Centered nav */}
      {isDesktop && (
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'flex-start', // align closer to logo
            ml: 1, // minimal gap between logo and nav
          }}
        >
          <HeaderDesktopNavMenu
            prodAnchor={prodAnchor}
            servAnchor={servAnchor}
            currentPage={currentPage}
            setProdAnchor={setProdAnchor}
            setServAnchor={setServAnchor}
            onNavigate={handleNavigate}
            onNavigateToTop={onNavigateToTop}
          />
        </Box>
      )}


      {/* Right CTA or mobile toggle */}
      {isDesktop
        ? (
          <Box sx={{ ml: 3 }}>
            <ScheduleDemoButton onClick={() => onNavigateToTop('/demo')} />
          </Box>
        )
        : (
          <Box sx={{display: 'flex', alignItems: 'center', gap: 1, marginLeft: 'auto' }}>
            <IconButton
              color="inherit"
              aria-label="Open menu"
              aria-haspopup="dialog"
              aria-expanded={mobileMenuOpen}
              aria-controls={mobileMenuOpen ? MOBILE_MENU_ID : undefined}
              sx={{ width: 44, height: 44, '&:hover': {bgcolor: 'transparent'}}}
              onClick={() => setMobileOpen(true)}
            >
              <MenuIcon />
            </IconButton>

            <MobileMenu
              open={mobileMenuOpen}
              currentPage={currentPage}
              onNavigate={handleNavigate}
              onClose={() => setMobileOpen(false)}
            />
          </Box>
        )}
    </HeaderRoot>
  );
}

Header.displayName = 'Header';
export default Header;
